import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function ChickenRoadPromoFun(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <InformationWrapper>
                <ImageWrapper>
                    <Container>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadFirstSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                           <Link to='/instant-games/inout/chicken-road-2' className='playNowBtn'><span>Play Now</span></Link>
                    </Container>
                </ImageWrapper> 

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadParticipateIcon1}`}/>
                            <p>Place 26 cash bet on chicken road 2 & get 26 free spins</p>
                        </KeyDetailsSecBox>
                             
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon2}`}/>
                            <p className='brandColor'>Qualify automatically</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadParticipateIcon1}`}/>
                            <p>Receive 26 free spins on <br /> Chicken Road 2</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>                

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li>✪ Valid from <strong>01 Jan 2026 to 28 February 2026</strong></li>
                        <li>✪ Free spin value: <strong>₹1</strong></li>
                        <li>✪ Valid for the first <strong>1,000 eligible players</strong></li>
                        <li>✪ Estimated total prize pool: <strong>₹13,00,000</strong></li>
                        <li>✪ Slot bonus rules apply</li>
                        <li>✪ Bonus winnings subject to wagering</li>
                        <li>✪ General <strong>Fun88</strong> terms & conditions apply</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(ChickenRoadPromoFun));

const TermsAndCondition = styled.div`
    width: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    border-radius: 8px;
    border: ${theme('palette.weeklySepLeaderboardTCBorder')};
    background: ${theme('palette.weeklySepLeaderboardTCBg')};
    padding: 1rem;
    
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #444;
            font-size: 16px;
            text-transform: capitalize;
        }
    }
`;

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1.5rem 0 1rem 0;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: #EBEBEB;
    overflow: hidden;
    gap: 1rem;

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .brandColor {
        color: #FFF;
        font-weight: 700;
    }

    .largeFont {
        font-size: 18px;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;
    width: 70%;
    margin: 1em auto 0 auto;
    margin-top: 0;
`;

const Container = styled.div`
    width: 275px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

    .playNowBtn {
        width: 220px;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 1.5rem;
        border-radius: 60px;
        border: ${theme('palette.suprChknRushPlayNowBtnBorder')};
        background: ${theme('palette.suprChknRushPlayNowBtnBgColor')};

        :hover {
            background: #04a6ff;
            border: 3px solid #0f7db9;
        }
    }
`;

const MainTitle = styled.h4`
        color: #06A6FF;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 35px;
        text-transform: capitalize;
        margin: 3px 0px 15px 0px;
`

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 70%;
    height: auto;
    background-color: #fff;
    padding: 1em 0;
    border-radius: 8px;
    
`

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    padding-bottom: 1rem;
`

const KeyDetailsSecBox = styled.div`
    width: 313px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    border-radius: 14px;
    border: 0.5px solid #8CD6FF;
    background: #06A6FF;

    img {
        width: 61px;
    }

    & p {
        color: #fff;
        text-align: center;
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`